import React from 'react';
import {
    FormControl,
    FormLabel,
  } from "@chakra-ui/react";
import Multiselect from 'multiselect-react-dropdown';

export const FormMultiSelect = ({ options, padding, label, selectProduct, removeProduct, selectedValues, displayValue, disable }) => {
    
    return (
        <FormControl padding={padding} colorScheme="brand">
            <FormLabel
                fontSize="15px"
                textTransform="capitalize"
                fontWeight={600}
            >
                {label}
            </FormLabel>
            <Multiselect
                options={options}
                selectedValues={selectedValues}
                onSelect={(selectedList) => selectProduct(selectedList)}
                onRemove={(selectedList, removedItem) =>
                    removeProduct(selectedList, removedItem)
                }
                displayValue={displayValue}
                showCheckbox={true}
                disable={disable}
            />
        </FormControl>
    );
};
